import ProductViewModel from "./ProductViewModel";
import ParentProductViewModel from "./ParentProductViewModel";
import CartViewModel from "./CartViewModel";

export default class ProductQuantityViewModel {
    public minReached = false;
    public itemMax = false;
    public outOfBounds = false;
    public allowMultiple = false;
    public errorMessage = "";

    public changeQty(productVm: ProductViewModel, pvm: ParentProductViewModel, cartVm: CartViewModel, amount: number) {
        const targetNum = parseInt(productVm.productQuantity.toString()) + amount;
        const oldQty = productVm.productQuantity;
        if (amount > 0) {
            if (targetNum <= this.calculateCurrentMax(productVm, pvm, cartVm)) {
                productVm.productQuantity++;
                this.minReached = false;
                this.errorMessage = "";
            } else {
                this.itemMax = true;
                this.errorMessage = "Max Quantity Reached";
            }
        } else {
            if (productVm.productQuantity != 1) {
                if (targetNum >= productVm.product!.minQuantity) {
                    productVm.productQuantity--;
                    this.itemMax = false;
                    this.errorMessage = "";
                } else {
                    this.minReached = true;
                    this.errorMessage = "Min Quantity Reached";
                }
            }
        }

        if (productVm.productQuantity != oldQty) {
            this.validateQuantity(productVm, pvm, cartVm, productVm.productQuantity);
        }
    }

    public validateQuantity(
        productVm: ProductViewModel,
        pvm: ParentProductViewModel,
        cartVm: CartViewModel,
        enteredNum: number
    ) {
        productVm.productQuantity = enteredNum;
        if (productVm.product) {
            const currentMax = this.calculateCurrentMax(productVm, pvm, cartVm);
            if (enteredNum < productVm.product.minQuantity || enteredNum > currentMax) {
                this.errorMessage =
                    "Product quantity must be between " + productVm.product.minQuantity + " and " + currentMax;
                this.outOfBounds = true;
            } else {
                this.outOfBounds = false;
                this.errorMessage = "";
                this.itemMax = false;
                this.minReached = false;
            }
        }
    }

    private getAdjustedGroupProductMaxQty(productVm: ProductViewModel, pvm: ParentProductViewModel) {
        let otherFinalizedGroupMemberCount = 0;
        pvm.pkgFinalizedGroupProductMembers.forEach((x) => {
            if (x.groupProductPkgFinalizedId !== productVm.groupProductPkgFinalizedId) {
                otherFinalizedGroupMemberCount += x.productQuantity;
            }
        });
        const adjustedGroupMaxQty = Math.max(
            0,
            productVm.productGroupDetails!.storeProductGroupMaxQuantity -
                productVm.productGroupDetails!.groupMemberCountInCart -
                otherFinalizedGroupMemberCount
        );
        return adjustedGroupMaxQty;
    }

    public calculateCurrentMax(productVm: ProductViewModel, pvm: ParentProductViewModel, cartVm: CartViewModel) {
        const designIds: any[] = [];
        let limit = productVm.product?.maxQuantity;

        if (productVm.selectedColor && productVm.selectedSize) {
            // adjust limit if this is a group product member
            if (productVm.productGroupDetails) {
                const adjustedGroupMaxQty = this.getAdjustedGroupProductMaxQty(productVm, pvm);
                limit = Math.min(limit ?? 0, adjustedGroupMaxQty);
            }

            if (productVm.selectedColor.eventProductColorID != "" && productVm.selectedSize != 0) {
                const colorId = productVm.selectedColor.eventProductColorId;
                const sizeId = productVm.selectedSize;
                const targetEntry = productVm.colorSize.colorSizeDictionary![colorId][sizeId];

                if (
                    (targetEntry && targetEntry.parentProductColorId != 0) ||
                    (targetEntry && targetEntry.parentProductSizeId != 0)
                ) {
                    if (
                        targetEntry.parentProductColorId in pvm.parent.colorSize.colorSizeDictionary! &&
                        targetEntry.parentProductSizeId in
                            pvm.parent.colorSize.colorSizeDictionary![targetEntry.parentProductColorId]
                    ) {
                        const parentSize =
                            pvm.parent.colorSize.colorSizeDictionary![targetEntry.parentProductColorId][
                                targetEntry.parentProductSizeId
                            ];
                        if (parentSize != null) {
                            if (parentSize.availableQuantity != null) {
                                if (parentSize.availableQuantity < limit!) {
                                    return parentSize.availableQuantity;
                                }
                            }
                        }
                    }
                }
                const colorSize = productVm.colorSize.colorSizeDictionary![colorId][sizeId];
                if (colorSize && colorSize.availableQuantity && colorSize.availableQuantity < limit!) {
                    return colorSize.availableQuantity;
                }
            }
        }

        if (productVm.product!.designCount > 1) {
            productVm.colorSize.designsObject.designs.forEach((design: any) => {
                designIds.push(design.value);
            });
        } else {
            designIds.push(productVm.product?.eventProductID);
        }
        let calculatedMax = cartVm.calculateCartMax(designIds, productVm.product!.maxQuantity, this.allowMultiple);

        // adjust calculated cart max if this is a group product member
        if (productVm.productGroupDetails) {
            const adjustedGroupMaxQty = this.getAdjustedGroupProductMaxQty(productVm, pvm);
            calculatedMax = Math.min(calculatedMax ?? 0, adjustedGroupMaxQty);
        }

        return calculatedMax;
    }
}
